module.exports = __webpack_public_path__ + "static/johndisilva-3e98cf334ebe9a334180e31ebed0047b.jpeg";